import type { Api_Product } from '@core/api'
import { ProductBuilder } from '@core/shopping/utils/factories/builders/productBuilder'

/**
 * Product factory able to produce a Api_Product object. Used
 * for hydration purposes.
 */
export const productFactory = (
  callback: (builder: ProductBuilder) => void,
  verifyRequiredFields?: boolean,
): Api_Product => {
  const builder = new ProductBuilder(verifyRequiredFields)
  callback(builder)

  return builder.build()
}
